import { AlertCircle, Inbox } from "lucide-react";
import styles from "./FeedbackStates.module.css";

export const EmptyState = ({
  icon = <Inbox size={28} />,
  title = "No data found",
  description = "There are currently no items to display in this view.",
  action,
  className = "",
}) => {
  return (
    <div className={`${styles.emptyStateContainer} ${className}`.trim()}>
      <div className={styles.emptyIconCircle}>{icon}</div>
      <h3 className={styles.emptyTitle}>{title}</h3>
      {description && <p className={styles.emptyDescription}>{description}</p>}
      {action && <div className={styles.emptyAction}>{action}</div>}
    </div>
  );
};

export const ErrorCard = ({
  title = "An error occurred",
  message,
  className = "",
}) => {
  return (
    <div className={`${styles.errorCard} ${className}`.trim()} role="alert">
      <AlertCircle size={18} className={styles.errorIcon} />
      <div className={styles.errorContent}>
        <div className={styles.errorTitle}>{title}</div>
        <p className={styles.errorText}>{message || "Please check your inputs and try again."}</p>
      </div>
    </div>
  );
};

export const LoadingSkeleton = ({
  width = "100%",
  height = "20px",
  borderRadius = "6px",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`${styles.skeleton} ${className}`.trim()}
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default EmptyState;
